import { useContext, useEffect } from 'react';
import MainContentClassContext from '../../context/MainContentClassContext';

// Lets a page apply an extra class to the layout's <main> for the duration it's
// mounted (e.g. a different page background), cleaning up on unmount.
const useMainContentClass = (className: string) => {
  const { setClassName } = useContext(MainContentClassContext);

  useEffect(() => {
    setClassName(className);
    return () => setClassName('');
  }, [className, setClassName]);
};

export default useMainContentClass;
